// extracted by mini-css-extract-plugin
export default {"popup":"index_popup__25bZp","code":"index_code__2_eld","actualCode":"index_actualCode__1xCIx","scan":"index_scan__2WKvF","frame":"index_frame__29lbx"};